var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57903 1.99932L14.9297 12.9993C15.0488 13.2056 15.0488 13.4597 14.9297 13.666C14.8106 13.8722 14.5905 13.9993 14.3524 13.9993H1.65102C1.41285 13.9993 1.19277 13.8722 1.07369 13.666C0.954603 13.4597 0.954604 13.2056 1.07369 12.9993L7.42436 1.99932C7.54345 1.79307 7.76353 1.66602 8.00169 1.66602C8.23986 1.66602 8.45993 1.79307 8.57903 1.99932V1.99932ZM2.80566 12.666H13.1977L8.00166 3.66602L2.80566 12.666H2.80566ZM7.33502 10.666H8.66836V11.9993H7.33502V10.666ZM7.33502 5.99927H8.66836V9.3326H7.33502V5.99927Z",
    fill: "#EEB046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlertIcon);
export default __webpack_public_path__ + "static/media/warningAlertIcon.527f3dd2f8437fced97983625667f01c.svg";
export { ForwardRef as ReactComponent };